
import React from 'react';

const NetworkBeigeUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='64'
			height='65'
			fill='none'
			viewBox='0 0 64 65'
		>
			<g fill='#FED2B4' clipPath='url(#clip0)'>
				<path d='M32 32.508c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-12c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zM16 34.508c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm0-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM42 52.508H22c-2.2 0-4-1.8-4-4v-2c0-6.62 6.28-12 14-12s14 5.38 14 12v2c0 2.2-1.8 4-4 4zm-10-14c-5.52 0-10 3.58-10 8v2h20v-2c0-4.42-4.48-8-10-8zM16 50.508H8c-2.2 0-4-1.8-4-4 0-5.52 5.38-10 12-10 .68 0 1.34.04 1.98.14l-.54 3.96c-.48-.06-.96-.1-1.44-.1-4.42 0-8 2.7-8 6h8v4zM48 34.508c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm0-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM56 50.508h-8v-4h8c0-3.3-3.58-6-8-6-.48 0-.96.04-1.44.1l-.54-3.96c.64-.1 1.3-.14 1.98-.14 6.62 0 12 4.48 12 10 0 2.2-1.8 4-4 4zM58 60.508H6v4h52v-4z'></path>
			</g>
			<defs>
				<clipPath id='clip0'>
					<path
						fill='#fff'
						d='M0 0H64V64H0z'
						transform='translate(0 .508)'
					></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default NetworkBeigeUnderline;
